function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_278",
  "data-name": "Path 278",
  d: "M927.291,209.394a3.925,3.925,0,0,1-1.27.708l-3.441,1.054v-3.94l2.835-.879a2.862,2.862,0,0,1,1.237.121,1.744,1.744,0,0,1,.848.937,2.764,2.764,0,0,1,.125,1.263m-19.875,6.921-1.086-3.687,15.026-4.5v4Zm-5.782,1.588-3.729-.733L900.7,213.8l5.1-1.507,1.05,3.566Zm26.248-9.752a2.737,2.737,0,0,0-3.4-1.828L900.4,212.87a.96.96,0,0,0-.362.206l-2.962,2.782a.9.9,0,0,0-.25.919.914.914,0,0,0,.714.635l4.009.695a.876.876,0,0,0,.156.014.777.777,0,0,0,.259-.038l19.81-5.906.087,1.867-6.3,1.878.3.855,6.3-1.805c.4-.117.668-.209.648-.625l-.236-2.455,3.8-1.089a2.725,2.725,0,0,0,1.833-3.388",
  transform: "translate(-875.863 -182.037)",
  fill: "#707070"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_321",
  "data-name": "Rectangle 321",
  width: 32.242,
  height: 13.766,
  transform: "translate(20.323 22.744)",
  fill: "none"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_279",
  "data-name": "Path 279",
  d: "M908.164,235.579H892.7V221.065h3.637v5.441a.907.907,0,0,0,.91.909h5.46a.907.907,0,0,0,.91-.909v-5.441h4.552ZM875.4,221.065h4.552v5.441a.907.907,0,0,0,.91.909h5.46a.91.91,0,0,0,.909-.909v-5.441h4.547v14.514H875.4Zm5.461,0h5.46v5.441h-5.46ZM875.4,206.55h4.552v5.441a.911.911,0,0,0,.91.91h5.46a.914.914,0,0,0,.909-.91V206.55h4.547v13.606H875.4Zm5.461,0h5.46v5.441h-5.46Zm16.378,14.515h5.46v5.441h-5.46Zm10.921-.91H892.7V206.55a.913.913,0,0,0-.914-.91H875.4a.908.908,0,0,0-.909.91v29.03a.906.906,0,0,0,.909.9h32.76a.907.907,0,0,0,.909-.9V221.065a.908.908,0,0,0-.909-.91",
  transform: "translate(-874.495 -182.047)",
  fill: "#707070"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_322",
  "data-name": "Rectangle 322",
  width: 35.341,
  height: 31.699,
  transform: "translate(0 22.744)",
  fill: "none"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_280",
  "data-name": "Path 280",
  d: "M898.984,185.231h2.553c.279,0-.172.22,0,0s.5-.457.433-.731l-1.164-2.861h7.28l-.91,2.861c-.069.273-.171.51,0,.731s.105,0,.389,0H910.7v2.539H898.984Zm-9.69,2.539a3.15,3.15,0,0,1,2.41-2.539h6.358v2.539h-5.448a.91.91,0,0,0-.91.9v13.61h.91v-13.61h23.662V204.1h.909V188.675a.906.906,0,0,0-.909-.9h-4.729v-2.539h5.637a3.208,3.208,0,0,1,2.463,2.539V203.19h1.18V187.77a3.64,3.64,0,0,0-3.643-3.628h-8.844l.626-2.5a.886.886,0,0,0-.166-.777.906.906,0,0,0-.713-.352h-7.28a.912.912,0,0,0-.884,1.129l.625,2.5H891.7a3.638,3.638,0,0,0-3.636,3.628v14.515h1.226V187.77",
  transform: "translate(-875.328 -180.506)",
  fill: "#707070"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_327",
  "data-name": "Rectangle 327",
  width: 35.043,
  height: 23.995,
  transform: "translate(11.561)",
  fill: "none"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_323",
  "data-name": "Rectangle 323",
  width: 1.818,
  height: 1.813,
  transform: "translate(29.118 48.996)",
  fill: "#707070"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_324",
  "data-name": "Rectangle 324",
  width: 1.818,
  height: 1.813,
  transform: "translate(12.74 48.996)",
  fill: "#707070"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_325",
  "data-name": "Rectangle 325",
  width: 1.818,
  height: 1.813,
  transform: "translate(12.74 34.482)",
  fill: "#707070"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Path_281",
  "data-name": "Path 281",
  d: "M921.456,227.336c.272,2.009-2.163,2.864-2.724,2.845h-5.461v.782h5.461a3.639,3.639,0,0,0,3.642-3.628v-8.164h-.824Z",
  transform: "translate(-876.874 -182.877)",
  fill: "#707070"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Path_282",
  "data-name": "Path 282",
  d: "M918.732,226.486v-6.351h-.91v6.351h-4.551v.91h4.551a.908.908,0,0,0,.91-.91",
  transform: "translate(-876.874 -182.936)",
  fill: "#707070"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "Path_283",
  "data-name": "Path 283",
  d: "M900.37,196.646h-3.637v-3.628h3.637Zm.914-3.628a.912.912,0,0,0-.914-.91h-3.637a.909.909,0,0,0-.91.91v3.628a.907.907,0,0,0,.91.9h3.637a.91.91,0,0,0,.914-.9v-3.628",
  transform: "translate(-875.804 -181.217)",
  fill: "#707070"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  id: "Path_284",
  "data-name": "Path 284",
  d: "M900.37,205.343h-3.637v-3.627h3.637Zm0-4.536h-3.637a.908.908,0,0,0-.91.91v3.627a.911.911,0,0,0,.91.91h3.637a.915.915,0,0,0,.914-.91v-3.627a.912.912,0,0,0-.914-.91",
  transform: "translate(-875.804 -181.75)",
  fill: "#707070"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_328",
  "data-name": "Rectangle 328",
  width: 1.818,
  height: 1.813,
  transform: "translate(27.299 10.893)",
  fill: "#707070"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_329",
  "data-name": "Rectangle 329",
  width: 10.921,
  height: 1.813,
  transform: "translate(27.299 14.52)",
  fill: "#707070"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_330",
  "data-name": "Rectangle 330",
  width: 7.284,
  height: 1.813,
  transform: "translate(30.937 10.893)",
  fill: "#707070"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_331",
  "data-name": "Rectangle 331",
  width: 1.818,
  height: 1.813,
  transform: "translate(27.299 19.057)",
  fill: "#707070"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_332",
  "data-name": "Rectangle 332",
  width: 10.921,
  height: 1.818,
  transform: "translate(27.299 22.684)",
  fill: "#707070"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_333",
  "data-name": "Rectangle 333",
  width: 7.284,
  height: 1.813,
  transform: "translate(30.937 19.057)",
  fill: "#707070"
});

function SvgInventory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_144_1",
    "data-name": "Component 144 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.564,
    height: 54.443,
    viewBox: "0 0 52.564 54.443",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.b313ee81b908be857b1bbc971d4991e1.svg";
export { ForwardRef as ReactComponent };